'use client';

import { useReducer } from 'react';
import type { AddressLookupAction, AddressLookupState } from '../types';

const initialState: AddressLookupState = {
  open: false,
  highlightedIndex: -1,
  isScrollable: false,
};

function addressLookupReducer(state: AddressLookupState, action: AddressLookupAction): AddressLookupState {
  switch (action.type) {
    case 'OPEN_DROPDOWN':
      return {
        ...state,
        open: action.payload,
        // Reset highlighted index when closing dropdown
        highlightedIndex: action.payload ? state.highlightedIndex : -1,
      };
    case 'SET_HIGHLIGHTED_INDEX':
      return {
        ...state,
        highlightedIndex: action.payload,
      };
    case 'SET_SCROLLABLE':
      return {
        ...state,
        isScrollable: action.payload,
      };
    case 'RESET':
      return initialState;
    default:
      return state;
  }
}

function useAddressLookupState() {
  const [state, dispatch] = useReducer(addressLookupReducer, initialState);

  const setOpen = (open: boolean) => dispatch({ type: 'OPEN_DROPDOWN', payload: open });
  const setHighlightedIndex = (index: number) => dispatch({ type: 'SET_HIGHLIGHTED_INDEX', payload: index });
  const setIsScrollable = (isScrollable: boolean) => dispatch({ type: 'SET_SCROLLABLE', payload: isScrollable });
  const reset = () => dispatch({ type: 'RESET' });

  return {
    ...state,
    setOpen,
    setHighlightedIndex,
    setIsScrollable,
    reset,
  };
}

export { addressLookupReducer, useAddressLookupState };
